import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AccessManagementComponent } from './components/access-management/access-management.component';
import { RouteGaurdService } from './common/services/route-gaurd.service';
import { MasterGlossaryComponent } from './components/master-glossary/master-glossary.component';
import { ErrorComponent } from './common/shared-components/error/error.component';
import { MyHistoryComponent } from './components/my-history/my-history.component';
import { MyAnnotationsComponent } from './components/my-annotations/my-annotations.component';
import { MyBookmarkComponent } from './components/my-bookmark/my-bookmark.component';
import { AboutUsComponent } from 'src/app/components/about-us/about-us.component';
import { CopyrightComponent } from 'src/app/components/copyright/copyright.component';
import { HelpComponent } from 'src/app/components/help/help.component';
import { TermsAndConditionsComponent } from 'src/app/components/terms-and-conditions/terms-and-conditions.component';
import { ClearSessionsService } from './common/services/clear-sessions.service';
import { LoginHomeComponent } from './components/Login/login-home/login-home.component';
import { SourceTracingToolComponent } from './components/source-tracing-tool/source-tracing-tool.component';
import { SearchComponent } from './components/search/search.component';
import { EffectiveDateComponent } from './components/effective-date/effective-date.component';
import { UnderDevelopmentComponent } from './components/under-development/under-development.component';
import { FinalPronouncementComponent } from './components/final-pronouncement/final-pronouncement.component';
import { HelpAnnotationsComponent } from './components/help/help-annotations/help-annotations.component';
import { HelpArchivedContentComponent } from './components/help/help-archived-content/help-archived-content.component';
import { HelpBrowsingComponent } from './components/help/help-browsing/help-browsing.component';
import { HelpBookmarksComponent } from './components/help/help-bookmarks/help-bookmarks.component';
import { HelpGlossaryTermFinderComponent } from './components/help/help-glossary-term-finder/help-glossary-term-finder.component';
import { HelpMyGarsComponent } from './components/help/help-my-gars/help-my-gars.component';
import { HelpMyHistoryComponent } from './components/help/help-my-history/help-my-history.component';
import { HelpPrintingComponent } from './components/help/help-printing/help-printing.component';
import { HelpRelatedContentComponent } from './components/help/help-related-content/help-related-content.component';
import { HelpSearchingComponent } from './components/help/help-searching/help-searching.component';
import { HelpSourceTracingComponent } from './components/help/help-source-tracing/help-source-tracing.component';
import { ImplementationGuideComponent } from './components/implementation-guide/implementation-guide.component';
import { PublicCommentComponent } from './components/public-comment/public-comment.component';
import { HelpContactusComponent } from './components/help/help-contactus/help-contactus.component';
import { HelpCopypasteComponent } from './components/help/help-copypaste/help-copypaste.component';
import { HelpShowallinonepageComponent } from './components/help/help-showallinonepage/help-showallinonepage.component';
import { PdflandingpageComponent } from './components/pdflandingpage/pdflandingpage.component';
import { ArchiveHomeComponent } from './components/archive-home/archive-home.component';
import { RedisCacheManagementComponent } from './components/redis-cache-management/redis-cache-management.component';
import { InternalViewRouteGuardService } from './common/services/internal-view-route-guard.service';
import { InternalAdminViewRouteGuardService } from './common/services/internal-admin-view-route-guard.service';
import { PDFBackupLandingPageComponent } from './components/pdfbackup-landing-page/pdfbackup-landing-page.component';
import { PDFBackupGaurdService } from './common/services/PDF-Backup-guard.service';

const publicationRouteMatcher = (url: UrlSegment[]) => {
  if (url.length >= 1 && url[0].path.match(/^[0-9]+$/gm)) {
    return {
      consumed: url.slice(0, 1),
      posParams: {
        publicationId: new UrlSegment(url[0].path, {}),
        // pageId: new UrlSegment(url[1].path, {}),
        // publicationSlug: new UrlSegment(url[2].path, {}),
        // pageSlug: new UrlSegment(url[3].path, {})
      }
    };
  }
  return null;
}
//export function aaaUrl(url: UrlSegment[]) {
//  return url.length > 0 && url[0].path.includes('home&u') ? ({ consumed: url }) : null;
//}


const routes: Routes = [
  {
    path: "GARSpdfs", component: PDFBackupLandingPageComponent,
    canActivate: [PDFBackupGaurdService],
    data: {
      title: 'GARS PDFs'
    }
  },
  {
    path: "PdfBackupContent", component: PDFBackupLandingPageComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'PDF BackUp Content'
    }
  },
  {

    path: ':/QuestionNotUsed',
    component: UnderDevelopmentComponent,
    data: {
      title: 'GARS - Question Not Used'
    }
  },
  {
    path: 'Login',
    loadChildren: () => import('./components/Login/Login.module').then(m => m.LoginModule),
    data: {
      title: 'GARS Login'
    }
  },
  {
    path: 'logout', component: LoginHomeComponent,
    canActivate: [ClearSessionsService]
  },
  //{
  //  component: HomeComponent,
  //  matcher: aaaUrl,
  //  canActivate: [RouteGaurdService],
  //  data: {
  //    title: 'Codification'
  //  }
  //},
  {
    path: 'ArchiveHome', component: ArchiveHomeComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'GARS Archive Home'
    }
  },
  {
    path: 'Home', component: HomeComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'GARS Home'
    }
  },
  {
    path: 'UnderDevelopment', component: UnderDevelopmentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'UnderDevelopment'
    }
  },
  {
    path: 'pageUnderDevelopment', component: UnderDevelopmentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'UnderDevelopment'
    }
  },
  {
    path: 'MyHistory', component: MyHistoryComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'My History'
    }
  },
  {
    path: 'myBookmarks', component: MyBookmarkComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'My Bookmarks'
    }
  },  {
    path: 'TocLinks', component: PdflandingpageComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'GASB Codification as of June 30, 2022'
    }
  },
  {
    path: 'myAnnotations', component: MyAnnotationsComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'My Annotations'
    }
  },
  {
    path: 'search',
    component: SearchComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Search'
    },
  },
  {
    path: 'MasterGlossary', component: MasterGlossaryComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Master Glossary'
    }
  },
  {
    path: 'finalpronouncements', component: FinalPronouncementComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'FinalPronouncement'
    }
  },
  {
    path: 'Error', component: ErrorComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Error Page '
    }
  },
  {
    path: "about-us", component: AboutUsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'About GARS'
    }
  },
  {
    path: "copy-right-GARSpdfs", component: CopyrightComponent,
    data: {
      title: 'Copyright'
    }
  },
  {
    path: "copy-right", component: CopyrightComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Copyright'
    }
  },
  {
    path: "contact-us", component: HomeComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Contact Us'
    }
  },
  {
    path: "help", component: HelpComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help'
    }
  }, 
  {
    path: "help-annotations", component: HelpAnnotationsComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'Help - Annotations'
    }
  },
  {
    path: "help-archive", component: HelpArchivedContentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Archive'
    }
  },
  {
    path: "help-browsing", component: HelpBrowsingComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Browsing'
    }
  },
  {
    path: "help-contactus", component: HelpContactusComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Contact Us'
    }
  },
  {
    path: "help-copyandpaste", component: HelpCopypasteComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Copy and Paste'
    }
  },
  {
    path: "help-bookmarks", component: HelpBookmarksComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'Help - Bookmarks'
    }
  },
  {
    path: "help-showallinonepage", component: HelpShowallinonepageComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Show All in One Page'
    }
  },
  {
    path: "help-glossarytermfinder", component: HelpGlossaryTermFinderComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Glossary Term Finder'
    }
  },
  {
    path: "help-mygars", component: HelpMyGarsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - My Gars'
    }
  },
  {
    path: "help-myhistory", component: HelpMyHistoryComponent,
    canActivate: [InternalViewRouteGuardService],
    data: {
      title: 'Help - My History'
    }
  },
  {
    path: "help-printing", component: HelpPrintingComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Printing'
    }
  },
  {
    path: "help-relatedcontent", component: HelpRelatedContentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Related Content'
    }
  },
  {
    path: "help-searching", component: HelpSearchingComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Searching'
    }
  },
  {
    path: "help-sourcetracing", component: HelpSourceTracingComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Help - Source Tracing'
    }
  },
  {
    path: "terms-and-conditions-GARSpdfs", component: TermsAndConditionsComponent,
    data: {
      title: 'Terms and Conditions'
    }
  },
  {
    path: "terms-and-conditions", component: TermsAndConditionsComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Terms and Conditions'
    }
  },
  {
    path: 'AccessManagement',
    component: AccessManagementComponent,
    canActivate: [InternalAdminViewRouteGuardService],
    data: {
      title: 'Access Management'
    }
  },
  {
    path: 'GlossaryTermFinder', component: MasterGlossaryComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Glossary Term Finder'
    }
  },
  {
    path: 'RedisCacheManagement',
    component: RedisCacheManagementComponent,
    canActivate: [InternalAdminViewRouteGuardService],
    data: {
      title: 'Redis Cache Management'
    }
  },
  {
    path: 'sourcetracingtool',
    component: SourceTracingToolComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Source Tracing Tool'
    }
  },
  {
    path: 'effectivedates',
    component: EffectiveDateComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Effective date'
    }
  },
  {
    path: 'implementationguides',
    component: ImplementationGuideComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'Implementation guide'
    }
  },
  {
    path: 'docspublicComment',
    component: PublicCommentComponent,
    canActivate: [RouteGaurdService],
    data: {
      title: 'public comment'
    }
  },
  {
    matcher: publicationRouteMatcher,
    canActivate: [RouteGaurdService],
    loadChildren: () => import('./modules/publication/publication.module').then(m => m.PublicationModule)
  },
  { path: '**', redirectTo: 'Login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }




